import { Component, Input, Output, ViewChild, ElementRef, EventEmitter, Renderer2 } from '@angular/core';
import { Media } from '@stuplay';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'media-button-upload',
    templateUrl: './media-button-upload.component.html',
})

export class MediaButtonUploadComponent {
    @Input() type: string = '';
    @Input() hidden: boolean = false;
    @Input() media: Media;
    @Output() updateMedia = new EventEmitter();
    @Output() deleteMedia = new EventEmitter();
    @Output() mediaModalOpen: EventEmitter<boolean> = new EventEmitter();
    @Output() onError = new EventEmitter();
    @ViewChild('downloadableMedia', { static: false }) aDownload: ElementRef;

    constructor(
        private renderer: Renderer2,
        private modalService: NgbModal,
    ) { }

    private savedScrollY = 0;
    // Teclas que provocan scroll: espacio, RePág, AvPág, Fin, Inicio, flechas.
    private readonly scrollKeys = [32, 33, 34, 35, 36, 37, 38, 39, 40];
    private blockWheel = (e: Event) => { e.preventDefault(); };
    private blockKeys = (e: KeyboardEvent) => {
        if (this.scrollKeys.indexOf(e.keyCode) !== -1) { e.preventDefault(); }
    };

    modalOpen(content: any, event?: MouseEvent) {
        const options: NgbModalOptions = {
            size: 'lg',
            backdrop: 'static', // clic fuera NO cierra el modal
            keyboard: false,     // Esc NO cierra el modal
            backdropClass: 'backdrop-media-upload',
            windowClass: 'window-media-upload'
        };
        // El modal debe aparecer justo donde está el botón (no en el centro de la
        // pantalla): calculamos la posición del botón y la pasamos por CSS var.
        this.positionModalAtButton(event);
        // Bloqueo total de scroll: el contenedor real es el documento (body/html), no #view.
        // Congelamos el body con position:fixed + offset y lo restauramos al cerrar/descartar.
        this.lockScroll();
        const ref = this.modalService.open(content, options);
        const unlock = () => this.unlockScroll();
        ref.result.then(unlock, unlock);
        this.mediaModalOpen.emit();
    }

    // Ancla el modal al centro vertical del botón que se clicó, dentro del viewport
    // (con un clamp para que no se salga por arriba/abajo). Escribe la coordenada en
    // la CSS var --media-modal-top que consume .modal.window-media-upload .modal-dialog.
    private positionModalAtButton(event?: MouseEvent): void {
        const target = event?.currentTarget as HTMLElement | null;
        if (!target || typeof target.getBoundingClientRect !== 'function') {
            document.documentElement.style.removeProperty('--media-modal-top');
            return;
        }
        const rect = target.getBoundingClientRect();
        const buttonCenter = rect.top + rect.height / 2;
        const half = 170; // mitad aprox. del alto del modal, para el clamp
        const top = Math.max(half + 12, Math.min(buttonCenter, window.innerHeight - half - 12));
        document.documentElement.style.setProperty('--media-modal-top', `${top}px`);
    }

    private lockScroll(): void {
        this.savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
        document.documentElement.classList.add('media-upload-modal-open');
        document.body.classList.add('media-upload-modal-open');
        document.body.style.top = `-${this.savedScrollY}px`;
        // Cancelamos los eventos que generan scroll (rueda, touch, teclas).
        window.addEventListener('wheel', this.blockWheel, { passive: false });
        window.addEventListener('touchmove', this.blockWheel, { passive: false });
        window.addEventListener('keydown', this.blockKeys, { passive: false } as any);
    }

    private unlockScroll(): void {
        window.removeEventListener('wheel', this.blockWheel, { passive: false } as any);
        window.removeEventListener('touchmove', this.blockWheel, { passive: false } as any);
        window.removeEventListener('keydown', this.blockKeys, { passive: false } as any);
        document.documentElement.classList.remove('media-upload-modal-open');
        document.body.classList.remove('media-upload-modal-open');
        document.body.style.top = '';
        document.documentElement.style.removeProperty('--media-modal-top');
        window.scrollTo(0, this.savedScrollY);
    }

    modalClose() {
        this.modalService.dismissAll();
        this.mediaModalOpen.emit();
    }

    onUpdateMedia(media: any) {
        console.log('=== DEBUG media-button-upload onUpdateMedia ===');
        console.log('media recibido:', media);
        console.log('media?.id:', media?.id);
        console.log('this.media:', this.media);
        console.log('this.media !== media:', this.media !== media);
        console.log('condicion (this.media !== media && media?.id):', this.media !== media && media?.id);

        if (this.media !== media && media?.id) {
            this.media = media;
            console.log('>>> EMITIENDO updateMedia:', this.media);
            this.updateMedia.emit(this.media);
        } else {
            console.log('>>> EMITIENDO onError - no paso la condicion');
            this.onError.emit();
        }

        this.modalService.dismissAll();
    }

    deletedMedia(media: any) {
        this.media = media;
        this.deleteMedia.emit(this.media);
    }

    displayMedia(): void {
        const event = new MouseEvent('click', { bubbles: true });
        (this.aDownload.nativeElement as any)['dispatchEvent'].apply(this.aDownload.nativeElement, [event]); // migration of code beneath
        // this.renderer.invokeElementMethod(this.aDownload.nativeElement, 'dispatchEvent', [event]);
    }

    dynamicUrl(media: any): string {
        let url: any;
        if (media.type === 'IMG') {
            url = `${environment.envVar.API_STOCKAGE_URL}/${media?.url}?size=raw`;
        } else {
            url = `${environment.envVar.API_STOCKAGE_URL}/${media?.originalUrl}`;
        }

        return url;
    }
}
